import { render, staticRenderFns } from "./PaymentGatePortal.vue?vue&type=template&id=79429873&"
import script from "./PaymentGatePortal.vue?vue&type=script&lang=js&"
export * from "./PaymentGatePortal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGatePortal.vue?vue&type=style&index=0&id=79429873&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports